import React from 'react';
export const TermsOfService = () => {
  return <div className="text-gray-700" data-id="element-190">
      <p className="mb-4" data-id="element-191">
        <strong data-id="element-192">Last Updated:</strong> September 1, 2025
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-193">1. Acceptance of Terms</h4>
      <p className="mb-4" data-id="element-194">
        By purchasing The Legacy #7 Collector's Edition and/or using our
        website, you agree to be bound by these Terms of Service. If you do not
        agree to these terms, please do not use our services.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-195">2. Products and Pricing</h4>
      <p className="mb-4" data-id="element-196">
        All product descriptions, including edition numbers and availability,
        are accurate to the best of our knowledge. We reserve the right to limit
        quantities and correct pricing errors. All prices are in USD unless
        otherwise noted.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-197">3. Limited Edition Status</h4>
      <p className="mb-4" data-id="element-198">
        The Legacy #7 Collector's Edition is a limited edition product. Once all
        copies are sold, no additional copies will be produced. Each copy is
        individually numbered and includes a certificate of authenticity.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-199">
        4. Order Acceptance and Fulfillment
      </h4>
      <p className="mb-4" data-id="element-200">
        All orders are subject to acceptance and availability. We reserve the
        right to refuse or cancel any order for any reason, including
        limitations on quantities available for purchase.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-201">5. Shipping and Delivery</h4>
      <p className="mb-4" data-id="element-202">
        We ship worldwide. Delivery times vary based on location. We are not
        responsible for delays due to customs or other factors beyond our
        control. Special handling is used for all shipments to ensure your
        collector's edition arrives in perfect condition.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-203">6. Returns and Refunds</h4>
      <p className="mb-4" data-id="element-204">
        Due to the limited edition nature of our product, all sales are final.
        However, if your item arrives damaged, please contact us within 7 days
        of receipt to arrange for a replacement, subject to availability.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-205">7. Intellectual Property</h4>
      <p className="mb-4" data-id="element-206">
        All content, including text, images, and design of The Legacy #7
        Collector's Edition, is protected by copyright and other intellectual
        property laws. You may not reproduce, distribute, or create derivative
        works without our express permission.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-207">8. Limitation of Liability</h4>
      <p className="mb-4" data-id="element-208">
        We shall not be liable for any indirect, incidental, special,
        consequential, or punitive damages resulting from your purchase or use
        of our products.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-209">9. Governing Law</h4>
      <p className="mb-4" data-id="element-210">
        These Terms of Service shall be governed by and construed in accordance
        with the laws of Portugal, without regard to its conflict of law
        provisions.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-211">10. Changes to Terms</h4>
      <p className="mb-4" data-id="element-212">
        We reserve the right to modify these Terms of Service at any time.
        Changes will be effective immediately upon posting on our website.
      </p>
      <h4 className="text-lg font-semibold mb-2" data-id="element-213">11. Contact Information</h4>
      <p className="mb-4" data-id="element-214">
        For questions about these Terms of Service, please contact us at
        terms@legacy7edition.com.
      </p>
    </div>;
};